import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';

/**
 * Déclenche la capture d'un snapshot pour un mois donné.
 * Body : { period_start: 'YYYY-MM-01' }
 * Invalide le cache cash-flow après succès pour recharger les données avec snapshot.
 */
export function useCaptureSnapshot() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ period_start }) =>
      api.post('/cash-flow/snapshot', { period_start }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['cash-flow'] });
    },
  });
}

/**
 * Lance le backfill des N derniers mois (défaut 12).
 * Query param : ?months=N
 * Invalide le cache cash-flow après succès.
 */
export function useBackfillSnapshots() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ months = 12 } = {}) =>
      api.post(`/cash-flow/snapshot/backfill?months=${months}`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['cash-flow'] });
    },
  });
}
